import { render, staticRenderFns } from "./SalesOrderPreviewBySupplierNew.vue?vue&type=template&id=2bbb66f1&"
import script from "./SalesOrderPreviewBySupplierNew.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPreviewBySupplierNew.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderPreviewBySupplierNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports